import { gql } from "@apollo/client";

export default gql`
  mutation CancelGroupRequest($requestId: ObjectId!) {
    cancelGroupRequest(requestId: $requestId)
  }
`;
